import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import BorderlessButton from '~/src/components/common/forms/Button/BorderlessButton';
import LinkButton from '~/src/components/common/forms/Button/LinkButton';

import xIcon from '../../../../static/img/xIcon.svg';

export default function MatchRow({ item, onClickX, onNoMatch, selected }): JSX.Element {
  const baseUrl = 'https://www.chocolate-brands.com/index.php?route=product/search&search=';
  const converted = item.nameChocolateSite.replace(' ', '%20');
  const fullUrl = baseUrl + converted;

  return (
    <div>
      <Button
        onClick={() => {
          onClickX(item);
        }}
        style={{
          backgroundColor: item.marked ? '#3c1a1a' : '#0b2e4d',
          border: selected ? '6px solid #673432' : '',
          color: item.gtinCu ? 'white' : '#ef7f1a',
        }}
      >
        {item.nameChocolateSite}
      </Button>
      {/* <Button
        onClick={() => {
          onNoMatch(item);
        }}
      >
        X
      </Button> */}
      <BorderlessButton
        onClick={() => {
          onNoMatch(item);
        }}
        icon={xIcon}
        iconSize={38}
      />
      {/* <a target="_blank" rel="noreferrer" href={fullUrl}>
        {` Link `}
      </a> */}
      <LinkButton title="Link" to={fullUrl} />
    </div>
  );
}
